<button id="main-menu-btn" mat-button [matMenuTriggerFor]="userMenu" style="color: #fff;" *ngIf="loggedIn()">
  <div class="status-circle" *ngIf="isOnline"></div>
  <div
    class="status-circle offline"
    *ngIf="!isOnline"
    [mdePopoverTriggerFor]="offlinePlanPopover"
    mdePopoverTriggerOn="hover">
  </div>
  <span *ngIf="currentUser && (currentUser.firstName || currentUser.lastName)">{{currentUser.firstName}} {{currentUser.lastName}}</span>
  <span *ngIf="currentUser && !currentUser.firstName && !currentUser.lastName">{{currentUser.email}}</span>
  <mat-icon>keyboard_arrow_down</mat-icon>
</button>
<mat-menu #userMenu="matMenu" [overlapTrigger]="false">
    <button mat-menu-item (click)="authService.editProfile()">Edit Profile</button>
    <button mat-menu-item (click)="exportDatabase()"><span>Export Database</span></button>
    <button mat-menu-item (click)="importDatabase()"><span>Import Database</span></button>
    <button mat-menu-item (click)="changePassword()"><span>Change Password</span></button>
    <button mat-menu-item *ngIf="canManageUsers()" [routerLink]="'manage'" [disabled]="!isOnline"><span>Manage Users</span></button>
    <button mat-menu-item (click)="startGuidedTour()"><span>Start Guided Tour</span></button>
    <button mat-menu-item (click)="disableGuidedTour()"><span>Disable Guided Tour</span></button>
  <!-- <button mat-menu-item (click)="openSupport()">
    <mat-icon>help</mat-icon>
    <span>Support</span>
  </button> -->
    <button mat-menu-item [disabled]="!isOnline" (click)="logout(loggedIn())">
    <mat-icon>exit_to_app</mat-icon>
    <span>Log Out</span>
  </button>
</mat-menu>
